import { AllAmenitiesViewModel, HighlightAmenitiesViewModel, PropertyInfoSectionViewModel } from 'models';
import * as React from 'react';
import { LocalizedText } from 'bernie-l10n';
import { ErrorBoundary } from 'bernie-view';
import { Amenities } from 'components/infosite/property-details/amenities';

interface HotelAmenitiesProps {
  amenities: AllAmenitiesViewModel;
  highlightAmenities: HighlightAmenitiesViewModel[];
  propertyAmenities: PropertyInfoSectionViewModel;
  header: string;
  isRefreshedHISLayout?: boolean;
}

const HotelAmenities: React.FunctionComponent<HotelAmenitiesProps> = ({
  amenities,
  highlightAmenities,
  propertyAmenities,
  header,
  isRefreshedHISLayout
}) => (
  <section>
    <h2 className={isRefreshedHISLayout ? 'uitk-type-500 all-b-padding-two' : 'is-visually-hidden'}>
      <LocalizedText message={header} />
    </h2>
    <ErrorBoundary label="hotel.information.details.amenities">
      <Amenities carouselAmenities={amenities.topSummary} highlightAmenities={highlightAmenities} propertyAmenities={propertyAmenities} />
    </ErrorBoundary>
  </section>
);

export { HotelAmenities };
